import { POST_LOGIN_REDIRECT_URI } from './POST_LOGIN_REDIRECT_URI';
export function getLoginUrl() {
    const href = new URL(window.location.href);
    href.searchParams.delete(POST_LOGIN_REDIRECT_URI);
    const url = new URL(window.location.origin);
    url.pathname = '/login';
    url.searchParams.append('start', 'true');
    url.searchParams.append(POST_LOGIN_REDIRECT_URI, href.toString());
    return url.toString();
}
export const DEFAULT_NAV = {
    primary: [
        {
            name: 'Discover',
            link: '/',
            authenticationStates: {
                authenticated: true,
                unauthenticated: true,
            },
        },
        {
            name: 'My Library',
            link: '/library',
            authenticationStates: {
                authenticated: true,
                unauthenticated: true,
            },
        },
        {
            name: 'Search',
            link: '/search',
            authenticationStates: {
                authenticated: true,
                unauthenticated: true,
            },
        },
    ],
    secondary: [
        {
            name: 'Account',
            link: '/account',
            authenticationStates: {
                authenticated: true,
                unauthenticated: false,
            },
        },
        {
            name: 'Sign In',
            link: getLoginUrl,
            authenticationStates: {
                authenticated: false,
                unauthenticated: true,
            },
        }
    ],
};
//# sourceMappingURL=DEFAULT_NAV.js.map